import * as React from "react"
import ArrowLink from "../components/arrowLink"

const CTA = ({ 
  image,
  heading = 'At MOTIV we work as an extension of your business – aligning culture, vision, and strategy to ensure our objectives are achieved from the outset.',
  text ='More about our services',
  link ='/services'
}) => {

  const formattedHeading = React.useMemo(() =>{
    return heading.split(' ').map((word,index) =>{
      if(word.toUpperCase() === 'MOTIV'){
        return <b key={index} >{word} </b>  
      }
      return <span key={index}>{` ${word} `}</span>
    })
  },[heading])

  return (
    <div className=" p40 pt0 pb0 ">
    <div className="cta--small   bb1 bt1 text-white m-pt40 m-pb60 p40 pl0 pr0  ">
      <p className="m0 h3 content--bolded mb40 ">{formattedHeading}</p>
      <div className="button inline">
        <ArrowLink to={link} text={text} />
      </div>
    </div>
    </div>
  )
}
export default CTA
